<template>
  <div class="anquan_container">
    <!-- <img src="@/assets/img/carbon/privacy.png" alt="privacy"> -->
    <i class="iconfont icon-anquanyinsi anquan"></i>
    <h3>{{ $t('privacy.title') }}</h3>
    <p>{{ $t('privacy.description') }}</p>
    <!-- <button class="toknow">{{ $t('privacy.learnMore') }}</button> -->
  </div>
</template>

<script>
export default {
  name: 'Privacy'
};
</script>

<style lang="scss" scoped>
.anquan_container {
  background-color: white;
  display: flex; /* 使用弹性布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  flex-direction: column;
  padding: 100px 0;
}

.anquan_container .anquan {
  font-size: 2.8vw;
  @media screen and (max-width: 768px) {
    height: 8vw;
    font-size: 4.8vw;
  }
}

.anquan_container h3 {
  font-size: 35px;
  color: #000;
  font-weight: 500;
  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
    color: #000;
    font-weight: 500;
  }
}


.anquan_container p {
  width: 50%;
  font-size: 16px;
  color: #090909;
  margin-bottom: 15px;
  text-align: center;
  @media screen and (max-width: 768px) {
    font-size: 1rem;
    color: #000;
  }
}

.anquan_container .toknow {
  background: #339216;
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 5px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    font-size: 0.8rem;
  }
}
</style>
